var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{attrs:{"message":_vm.message,"title-class":_vm.$style.title,"show-body":false}})}
var staticRenderFns = []

export { render, staticRenderFns }